/**
 * Wires up the mutually-exclusive gift-option radios rendered by
 * sections/sb-gift-rules.liquid (`.sb-gift-group[data-has-choice="true"]`), once
 * assets/sb-gift-display.js has relocated that group into the current product's
 * .sb-gift-slot. Injects a hidden `properties[_gift_choice]` input into the real
 * add-to-cart <form> so the customer's pick travels with the trigger product itself —
 * both the regular "Add to cart" flow (product-form.js, Dawn-native) and the custom
 * "Buy it now" flow (assets/sb-product.js, which does `new FormData(form)` on the same
 * element) pick it up with no changes of their own. assets/gift-with-purchase.js then
 * reads this property back off the cart line to decide which option's gift to add.
 */
(function () {
  'use strict';

  document.querySelectorAll('.sb-gift-group[data-has-choice="true"]').forEach(function (group) {
    var radios = group.querySelectorAll('.sb-gift-option__radio');
    if (!radios.length) return;

    var container = group.closest('.product__info-container');
    var form = container && container.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    var input = form.querySelector('input[name="properties[_gift_choice]"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_gift_choice]';
      form.appendChild(input);
    }

    function applySelection() {
      var checked = group.querySelector('.sb-gift-option__radio:checked');
      input.value = checked ? checked.value : '';
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', applySelection);
    });

    applySelection();
  });
})();
